import AppliedFilters from "components/common/AppliedFilters";

interface ExtensionsAppliedFiltersProps {
    handleClearFilters: () => void;
    handleRemoveFilter?: (key: string) => void;
    filters: any
}

export default function ExtensionsAppliedFilters({ handleClearFilters, handleRemoveFilter, filters }: ExtensionsAppliedFiltersProps) {
    const hasAny = Boolean(
        (filters.status && filters.status.length)
    )

    if (!hasAny) return null

    const pills: { key: string; label: string, value?: string }[] = []
    if (filters.status && filters.status.length) {
        pills.push({ 
            key: 'status', 
            label: 'Status',
            value: filters.status.length === 1 ? filters.status[0] : `${filters.status.length} selected`
        })
    }

    return (
        <AppliedFilters 
            pills={pills} 
            handleClearFilters={handleClearFilters} 
            handleRemoveFilter={handleRemoveFilter} 
        />
    )
}
